export default "__VITE_ASSET__BAEtEU87__"